import { useEffect } from "react";
import { useComputedColorScheme } from "@mantine/core";

const lightThemeColor = "#1791b8";
const darkThemeColor = "#11212f";

export function ThemeMeta() {
    const colorScheme = useComputedColorScheme("light", { getInitialValueInEffect: true });

    useEffect(() => {
        const meta = document.querySelector('meta[name="theme-color"]');
        if (!meta) {
            return;
        }
        meta.setAttribute("content", colorScheme === "dark" ? darkThemeColor : lightThemeColor);
    }, [colorScheme]);

    return null;
}
